import { pluralRu } from '../../plural';

export const store = {
  navTitle: 'Магазин',
  pageTitle: {
    terms: 'Условия получения и возврата',
    order: 'Заказ'
  },
  shop: {
    kicker: 'Официальный магазин',
    title: 'Магазин Ratten Run',
    subtitle: 'Свои лобби, VIP-подписка и монеты для Ratten Run. Разовая оплата без автопродления, код приходит на email сразу после оплаты.',
    loading: 'Загружаем каталог…',
    loadFailed: 'Не удалось загрузить товары',
    emptyCatalog: 'Каталог пока пуст',
    categoriesAria: 'Разделы каталога',
    categories: {
      host: {
        title: 'Свои лобби',
        description: 'Создавайте собственные лобби и играйте с друзьями. Срок начинается с момента активации кода.'
      },
      supporter: {
        title: 'VIP-подписка',
        description: 'Больше наград за матчи и VIP-функции в игре. Включается автоматически на ваш игровой UID.'
      },
      currency: {
        title: 'Монеты',
        description: 'Валюта для внутриигрового магазина Ratten Run. Код активации приходит сразу после оплаты.'
      },
      tag: {
        title: 'Свой тег',
        description: 'Ваш тег рядом с ником в матчах: свой текст, цвета и иконка. Покупка навсегда.'
      }
    },
    badge: {
      popular: 'Популярное',
      bestValue: 'Выгодно'
    },
    coinBonus: {
      badge: (percent: number): string => `+${percent}%`,
      hint: (percent: number): string => `на ${percent}% больше монет за рубль`
    },
    accessDays: (days: number): string => `${days} ${pluralRu(days, 'день', 'дня', 'дней')} · без автопродления`,
    coins: (coins: string): string => `${coins} монет · код активации`,
    trust: {
      label: 'Гарантии покупки',
      payment: {
        title: 'Защищённая оплата',
        text: 'Оплата на защищённой странице платёжного сервиса — данные карты мы не видим и не храним.'
      },
      delivery: {
        title: 'Выдача сразу после оплаты',
        text: 'Код появится на странице заказа и придёт на email.'
      },
      deliveryModeration: {
        title: 'Модерация после оплаты',
        text: 'Тег проверит модератор, статус виден на странице заказа. После одобрения тег появится у вас в игре.'
      },
      support: {
        title: 'Поддержка',
        text: 'Если что-то пошло не так — напишите на'
      }
    },
    custom: {
      amountLabel: 'Количество монет',
      rangeHint: (min: string, max: string, step: string): string =>
        `От ${min} до ${max} монет, кратно ${step}`,
      invalid: (min: string, max: string, step: string): string =>
        `Введите количество от ${min} до ${max}, кратное ${step}`,
      quick: 'Быстрый выбор',
      calculating: 'Считаем цену…',
      unavailable: 'Свой ввод временно недоступен',
      quoteFailed: 'Не удалось рассчитать цену. Повторите ввод.',
      perCoin: (price: string): string => `≈ ${price} за монету`,
      orderName: (coins: string): string => `${coins} монет`
    },
    term: {
      groupAria: 'Срок подписки',
      months: (months: number): string => `${months} мес.`,
      discountBadge: (percent: string): string => `−${percent}%`,
      discountHint: (percent: string): string => `Скидка ${percent}% по сравнению с оплатой по месяцам`,
      perMonth: (price: string): string => `≈ ${price} / мес.`,
      orderName: (name: string, months: number): string => `${name} — ${months} мес.`
    }
  },
  checkout: {
    title: 'Оформление заказа',
    selectedLabel: 'Вы выбрали',
    nothingSelected: 'Выберите товар в каталоге',
    uidLabel: 'Игровой UID',
    uidPlaceholder: 'Например, 42917730',
    uidFromAccount: 'Подставлен из вашего профиля',
    emailLabel: 'Email для получения ключа',
    emailLabelSupporter: 'Email для подтверждения',
    accessKeyLabel: 'Ключ доступа',
    accessKeyPlaceholder: 'Введите ключ доступа',
    emailPlaceholder: 'you@example.com',
    paymentMethod: 'Способ оплаты',
    paymentMethodHints: {
      platega: 'СБП, криптовалюта',
      funpay: 'Карты RU и BY, СБП, ЕРИП, USDT TRC20, Litecoin'
    } as Record<string, string>,
    paymentSoonTitle: 'Онлайн-оплата скоро будет подключена',
    paymentSoonText: 'Заказ можно оформить уже сейчас — оплата будет отмечена вручную.',
    consentPrefix: 'Я принимаю условия',
    offerLink: 'публичной оферты',
    consentAnd: 'и',
    termsLink: 'условия получения и возврата',
    consentPrivacy: ', даю согласие на обработку персональных данных в соответствии с',
    privacyLink: 'политикой конфиденциальности',
    submit: 'Оформить заказ',
    submitting: 'Создаём заказ…',
    priceUnknown: 'укажите количество',
    instructions: {
      host: 'После оплаты код появится на странице заказа и придёт на email. Активируйте его на Discord-сервере Ratten Run: в канале #hoster-доступ нажмите «Активировать ключ хостера» и вставьте код. Срок пойдёт с момента активации.',
      supporter: 'VIP включится автоматически на указанный UID сразу после оплаты — ничего активировать не нужно. Подтверждение придёт на email.',
      currency: 'После оплаты код появится на странице заказа и придёт на email. Активируйте его в игре: откройте магазин (кнопка слева сверху) и введите код в поле «Промокод» справа сверху. UID указывать не нужно.',
      tag: 'После оплаты тег уйдёт на модерацию, затем появится у вас в игре. Модератор может написать вам по указанному контакту, если тег придётся поправить.'
    },
    errors: {
      terms: 'Примите условия оферты и согласие на обработку персональных данных.',
      uid: 'UID должен содержать от 1 до 20 цифр.',
      email: 'Введите корректный email для подтверждения покупки.',
      createFailed: 'Не удалось создать заказ',
      retryHint: 'Можно повторить попытку.',
      PRODUCT_NOT_FOUND: 'Товар недоступен. Обновите страницу и выберите другой.',
      PLAYER_NOT_FOUND: 'Игрок с таким UID не найден. Проверьте UID.',
      REQUEST_ID_CONFLICT: 'Данные заказа изменились. Повторите оформление.',
      INVALID_EMAIL: 'Введите корректный email.',
      INVALID_UID: 'UID должен содержать от 1 до 20 цифр.',
      STORE_ACCESS_DENIED: 'Неверный ключ доступа.',
      INVALID_ACCESS_KEY: 'Неверный ключ доступа.',
      STORE_UNAVAILABLE: 'Магазин временно недоступен. Повторите позже.',
      PAYMENT_METHOD_REQUIRED: 'Выберите способ оплаты.',
      PAYMENT_METHOD_UNAVAILABLE: 'Выбранный способ оплаты сейчас недоступен. Выберите другой.',
      INVALID_PAYMENT_METHOD: 'Некорректный способ оплаты. Выберите другой.',
      PAYMENT_CREATE_FAILED: 'Не удалось создать платёж. Повторите попытку.',
      INVALID_REQUEST: 'Некорректный запрос. Обновите страницу и повторите.',
      CUSTOM_COINS_UNAVAILABLE: 'Свой ввод монет временно недоступен. Выберите готовый пакет.',
      INVALID_COINS: 'Недопустимое количество монет. Проверьте диапазон и шаг.',
      NOT_CUSTOM_PRODUCT: 'Для этого товара нельзя указать своё количество. Обновите страницу.',
      AMOUNT_EXCEEDS_LIMIT: 'Сумма заказа больше 10 000 ₽. Выберите меньшее количество.',
      TAG_REQUIRED: 'Для этого товара нужно оформить тег. Обновите страницу.',
      TAG_NOT_ALLOWED: 'Для этого товара тег не указывается. Обновите страницу.',
      AUTH_REQUIRED: 'Войдите через Steam: тег привязывается к вашему игровому аккаунту.',
      INVALID_TAG_NAME: 'Недопустимый текст тега: 2–20 символов, буквы, цифры, пробел и _ . - !',
      INVALID_TAG_COLORS: 'Недопустимые цвета тега: нужно от 1 до 6 цветов.',
      INVALID_TAG_ANGLE: 'Недопустимое направление градиента.',
      INVALID_TAG_ICON: 'Иконку не удалось принять. Загрузите другое изображение или уберите иконку.',
      CONTACT_REQUIRED: 'Укажите, как с вами связаться (не короче 2 символов).',
      CONTACT_TOO_LONG: 'Контакт слишком длинный (не более 500 символов).',
      INVALID_CONTACT: 'В контакте есть недопустимые невидимые символы. Перепечатайте его вручную.',
      PLAYER_REQUIRED: 'К аккаунту не привязан игровой профиль. Зайдите хотя бы в одну игру Ratten Run и повторите.',
      TOO_MANY_PENDING_TAG_ORDERS: 'Слишком много неоплаченных заказов тегов. Оплатите прежние или повторите через сутки.',
      ICON_STORE_FAILED: 'Не удалось сохранить иконку. Повторите позже или оформите тег без иконки.',
      INVALID_TERM: 'Этот срок подписки недоступен. Обновите страницу и выберите другой.',
      TERM_NOT_ALLOWED: 'Для этого товара выбор срока недоступен. Обновите страницу.'
    }
  },
  myOrders: {
    title: 'Мои заказы',
    loading: 'Загружаем заказы…',
    loadFailed: 'Не удалось загрузить заказы',
    empty: 'У вас пока нет заказов.',
    open: 'Открыть',
    openAria: (name: string): string => `Открыть заказ: ${name}`,
    prev: 'Назад',
    next: 'Вперёд',
    summary: (page: number, total: number): string => `Страница ${page} из ${total}`
  },
  status: {
    test: 'Тестовый',
    order: {
      pending: 'Ожидает оплаты',
      paid: 'Оплачен',
      canceled: 'Отменён'
    },
    fulfillment: {
      pending: 'Выдача ожидает',
      completed: 'Выдан',
      failed: 'Ошибка выдачи'
    },
    email: {
      pending: 'Письмо в очереди',
      sent: 'Письмо отправлено',
      failed: 'Ошибка письма',
      skipped: 'Письмо не отправлялось'
    }
  },
  errorCodes: {
    FULFILLMENT_RETRYING: 'Выдача временно задерживается, мы повторяем попытку автоматически.',
    FULFILLMENT_FAILED: 'Не удалось выдать товар автоматически. Повторно оплачивать заказ не нужно.'
  },
  order: {
    badge: 'Заказ',
    numberLabel: 'Номер заказа',
    copyOrderId: 'Скопировать номер заказа',
    checkNow: 'Проверить сейчас',
    backToStore: 'Вернуться в магазин',
    contactSupport: 'Обратиться в поддержку',
    checkingTitle: 'Проверяем заказ',
    checkingHint: 'Это обычно занимает несколько секунд. Не закрывайте страницу.',
    unavailableTitle: 'Заказ недоступен',
    accessMissing: 'Данные доступа к заказу не найдены. Откройте ссылку из письма или заказ на устройстве, где вы его оформляли.',
    checkFailed: 'Не удалось проверить заказ',
    notFound: 'Заказ не найден. Проверьте ссылку.',
    updateFailed: 'Не удалось обновить статус:',
    pendingTitle: 'Ожидаем оплату',
    pendingText: 'Заказ создан и ждёт подтверждения оплаты. Страница обновится автоматически.',
    pendingPaymentLink: 'Перейти к оплате',
    activatingTitle: 'Оплата подтверждена, выдаём покупку',
    activatingText: 'Выдача ещё не завершена — страница обновится автоматически.',
    failedTitle: 'Не удалось выдать покупку',
    failedText: 'Повторно оплачивать заказ не нужно. Сохраните номер заказа и обратитесь в поддержку для ручной проверки.',
    canceledTitle: 'Заказ отменён',
    canceledText: 'Оплата не была завершена. Если банк показывает списание, обратитесь в поддержку с номером заказа.',
    hostReadyTitle: 'Код хостинга готов',
    hostCodeLabel: 'Ваш код хостинга',
    currencyReadyTitle: 'Промокод готов',
    currencyCodeLabel: 'Ваш промокод',
    activation: {
      host: {
        title: 'Как активировать',
        steps: [
          'Перейдите на Discord-сервер Ratten Run.',
          'Откройте канал #hoster-доступ.',
          'Нажмите «Активировать ключ хостера» и вставьте код.'
        ],
        note: 'Срок доступа начинается с момента активации.',
        openDiscord: 'Открыть Discord'
      },
      currency: {
        title: 'Как активировать',
        steps: [
          'Зайдите в матч Ratten Run.',
          'Откройте магазин: кнопка в левом верхнем углу экрана.',
          'В правом верхнем углу магазина введите код в поле «Промокод» и нажмите «Активировать».'
        ],
        note: 'Монеты зачисляются на ваш игровой аккаунт сразу после активации.'
      }
    },
    subscriptionTitle: 'Подписка активирована',
    subscriptionUntil: 'Подписка действует до',
    subscriptionText: 'VIP-подписка включена или продлена автоматически. Ничего активировать не нужно.',
    copy: 'Копировать',
    copied: 'Скопировано',
    copyFailed: 'Не удалось скопировать. Выделите текст и скопируйте вручную.',
    emailSent: 'Копия отправлена на email',
    emailPending: 'Отправляем копию на email…',
    emailFailed: 'Письмо не удалось отправить — сохраните код со страницы.',
    longWait: 'Если статус долго не меняется, сохраните номер заказа и обратитесь в поддержку.',
    funpay: {
      title: 'Оплатите заказ на FunPay',
      lead: 'Оплата проходит на FunPay. Код заказа нужен, чтобы продавец связал вашу покупку с этим заказом.',
      codeLabel: 'Код заказа',
      codeBadge: 'Отправьте продавцу именно этот код',
      codeHint: 'Продавцу нужен именно этот код, он начинается с RR-. Номер заказа внизу страницы отправлять не нужно.',
      stepsLabel: 'Как оплатить',
      step1: 'Купите лот на FunPay.',
      openLot: 'Открыть лот на FunPay',
      step2: 'Сразу после покупки отправьте код RR-… продавцу в чат FunPay.',
      step3: 'Дождитесь выдачи: эта страница обновится сама.'
    },
    uidLine: (product: string, uid: string): string => `${product} · UID ${uid}`
  },
  terms: {
    back: '← На главную',
    heading: 'Условия получения и возврата',
    sections: [
      {
        title: 'Что продаётся',
        paragraphs: [
          'В магазине продаются цифровые услуги и товары для пользовательской игры Ratten Run в Dota 2: доступ к хостингу собственных лобби на 7, 30 или 90 дней, VIP-подписка на 1 месяц и наборы игровой валюты. Состав, срок и цена в рублях указаны в карточке товара до оплаты. Покупки разовые, автоматического продления и повторных списаний нет.'
        ]
      },
      {
        title: 'Оплата',
        paragraphs: [
          'Оплата производится единовременно банковской картой или другим способом, доступным на защищённой странице платёжного сервиса. Данные карты вводятся только на стороне платёжного сервиса и магазину не передаются. После оплаты формируется чек.'
        ]
      },
      {
        title: 'Способы и сроки получения',
        paragraphs: [
          'Все товары предоставляются только в электронном виде, доставка бесплатна. Физическая доставка не осуществляется.',
          'Хостинг: код доступа отображается на странице заказа сразу после подтверждения оплаты (обычно в течение нескольких минут) и дублируется на указанный email. Код активируется на Discord-сервере Ratten Run: в канале #hoster-доступ нужно нажать «Активировать ключ хостера» и вставить код; срок доступа начинается с момента активации.',
          'Игровая валюта: ключ отображается на странице заказа сразу после подтверждения оплаты и дублируется на email. Ключ активируется внутри игры Ratten Run: в магазине (кнопка в левом верхнем углу) нужно ввести его в поле «Промокод» справа вверху и нажать «Активировать».',
          'VIP-подписка: активируется автоматически на указанный игровой UID после подтверждения оплаты, не позднее 24 часов. Подтверждение приходит на email.'
        ]
      },
      {
        title: 'Отказ от покупки и возврат денежных средств',
        paragraphs: [
          'Вы вправе отказаться от цифрового товара или услуги надлежащего качества и вернуть уплаченную сумму в течение 7 дней, не считая дня покупки, без указания причины.',
          'От хостинга или подписки можно отказаться в любой момент оплаченного срока: возвращается сумма за неиспользованную часть срока.',
          'Если код или ключ не выдан, не работает или не даёт оплаченного результата, мы заменим его или вернём деньги полностью.'
        ]
      }
    ],
    refundHowTitle: 'Как оформить возврат',
    refundHowIntro: 'Напишите на ',
    refundHowDetails: '. Укажите номер заказа, дату, сумму и требование. Не отправляйте ключ активации, данные банковской карты или ссылку доступа к заказу.',
    refundTiming: 'Обращение рассматривается в течение 10 календарных дней со дня получения. Деньги возвращаются тем же способом, которым была произведена оплата (на ту же банковскую карту или счёт); срок зачисления зависит от банка.',
    offerNote: 'Полные условия — в ',
    offerLink: 'публичной оферте',
    moderationCode: (code: string): string => `Код согласования: ${code}`
  },
  admin: {
    kicker: 'Админка',
    title: 'Магазин',
    tabsAria: 'Разделы магазина',
    tabs: {
      orders: 'Заказы',
      analytics: 'Аналитика',
      products: 'Товары',
      categories: 'Категории',
      payments: 'Способы оплаты',
      tags: 'Теги'
    },
    common: {
      loading: 'Загрузка…',
      retry: 'Повторить',
      all: 'Все',
      cancel: 'Отмена',
      save: 'Сохранить',
      page: (page: number, total: number): string => `Страница ${page} из ${total}`,
      total: (count: string): string => `Всего: ${count}`,
      invalidRange: 'Дата начала должна быть раньше даты окончания',
      utcHint: 'Даты в UTC',
      prev: 'Назад',
      next: 'Вперёд'
    },
    apiErrors: {
      INVALID_FUNPAY_LOT_ID: 'ID лота FunPay: только цифры, от 1 до 20.',
      FUNPAY_LOT_TAKEN: 'Этот лот FunPay уже привязан к другому товару или сроку.',
      FUNPAY_LOT_NOT_ALLOWED: 'Лот FunPay нельзя задать товару с выбором количества монет — у него нет фиксированной цены.',
      INVALID_FUNPAY_LOT_TITLE: 'Название лота — до 255 символов.',
      FUNPAY_ORDER_ALREADY_USED: 'Этот заказ FunPay уже привязан к другому заказу магазина.',
      generic: 'Не удалось выполнить действие',
      ORDER_CANCELED: 'Заказ уже отменён.',
      ORDER_NOT_CANCELABLE: 'Заказ нельзя отменить: он уже оплачен или отменён.',
      NOTHING_TO_RETRY: 'Повторять нечего: выдача и письмо не в состоянии ошибки.',
      ORDER_NOT_FOUND: 'Заказ не найден.',
      COMMENT_REQUIRED: 'Укажите комментарий.',
      COMMENT_TOO_LONG: 'Комментарий слишком длинный (не более 500 символов).',
      STORE_UNAVAILABLE: 'Магазин временно недоступен. Повторите позже.',
      INVALID_REQUEST: 'Некорректный запрос.',
      INVALID_PERIOD: 'Некорректный период: дата начала должна быть раньше даты окончания.',
      INVALID_FILTER: 'Некорректные параметры фильтра.',
      NAME_REQUIRED: 'Укажите название.',
      NAME_TOO_LONG: 'Название слишком длинное (не более 255 символов).',
      DESCRIPTION_REQUIRED: 'Укажите описание.',
      DESCRIPTION_TOO_LONG: 'Описание слишком длинное.',
      FEATURE_BLANK: 'Особенность не может быть пустой.',
      FEATURES_REQUIRED: 'Укажите список особенностей (можно пустой).',
      PRODUCT_ID_REQUIRED: 'Укажите ID товара.',
      PRODUCT_ID_TOO_LONG: 'ID товара слишком длинный.',
      INVALID_PRODUCT_ID: 'ID товара: только латиница в нижнем регистре, цифры и дефис, 3–64 символа.',
      PRICE_REQUIRED: 'Укажите цену.',
      CATEGORY_REQUIRED: 'Выберите категорию.',
      CURRENCY_REQUIRED: 'Укажите валюту.',
      INVALID_CURRENCY: 'Поддерживается только RUB.',
      INVALID_IMAGE_URL: 'Некорректная картинка. Загрузите файл заново.',
      FEATURE_TOO_LONG: 'Особенность слишком длинная (не более 255 символов).',
      TOO_MANY_FEATURES: 'Слишком много особенностей (не более 20).',
      INVALID_PRICE: 'Некорректная цена: больше нуля, не более двух знаков после запятой.',
      PRICE_EXCEEDS_LIMIT: 'Цена больше лимита платёжного сервиса (10 000 ₽).',
      INVALID_USD_PRICE: 'Некорректная цена в USD: больше нуля, не более двух знаков после запятой.',
      INVALID_FULFILLMENT_VALUE: 'Некорректное значение выдачи.',
      INVALID_BADGE: 'Некорректная метка.',
      PRODUCT_NOT_FOUND: 'Товар не найден.',
      PAYMENT_METHOD_NOT_CONFIGURED: 'Секреты способа оплаты не настроены',
      PAYMENT_METHOD_NOT_FOUND: 'Способ оплаты не найден.',
      ENABLED_REQUIRED: 'Укажите, включить или выключить способ оплаты.',
      PRODUCT_ID_TAKEN: 'Товар с таким ID уже существует.',
      STORE_CATEGORY_NOT_FOUND: 'Категория не найдена.',
      TITLE_RU_REQUIRED: 'Укажите название (RU).',
      TITLE_RU_TOO_LONG: 'Название (RU) слишком длинное (не более 64 символов).',
      TITLE_EN_REQUIRED: 'Укажите название (EN).',
      TITLE_EN_TOO_LONG: 'Название (EN) слишком длинное (не более 64 символов).',
      DESCRIPTION_RU_REQUIRED: 'Укажите описание (RU), можно пустое.',
      DESCRIPTION_RU_TOO_LONG: 'Описание (RU) слишком длинное (не более 500 символов).',
      DESCRIPTION_EN_REQUIRED: 'Укажите описание (EN), можно пустое.',
      DESCRIPTION_EN_TOO_LONG: 'Описание (EN) слишком длинное (не более 500 символов).',
      SORT_ORDER_REQUIRED: 'Укажите порядок сортировки.',
      SORT_ORDER_INVALID: 'Порядок сортировки — целое число от 0 до 1000.',
      TAG_REQUEST_NOT_FOUND: 'Заявка на тег не найдена.',
      TAG_REQUEST_NOT_PENDING: 'Заявка уже обработана: действие доступно только для тегов на модерации.',
      INVALID_TAG_NAME: 'Недопустимый текст тега: 2–20 символов, буквы, цифры, пробел и _ . - !',
      INVALID_TAG_COLORS: 'Недопустимые цвета тега: нужно от 1 до 6 цветов.',
      INVALID_TAG_ANGLE: 'Недопустимое направление градиента.',
      INVALID_TAG_ICON: 'Иконку не удалось принять. Загрузите другое изображение.',
      ICON_STORE_FAILED: 'Не удалось сохранить иконку. Повторите позже.',
      PLAYER_NOT_FOUND: 'Игрок заявки не найден: тег некому назначить.',
      TERMS_NOT_ALLOWED: 'Сроки подписки можно задать только товару из категории «Подписка».',
      DUPLICATE_TERM: 'Сроки не должны повторяться.',
      INVALID_TERM_MONTHS: 'Срок — целое число месяцев от 2 до 24.',
      TERM_DISCOUNT_TOO_HIGH: 'Скидка срока не может быть больше максимальной скидки товара.',
      INVALID_TERM_MAX_DISCOUNT: 'Максимальная скидка — целое число от 0 до 50.'
    },
    orders: {
      filters: {
        status: 'Статус',
        testType: 'Тип заказа',
        testRegular: 'Обычные',
        testOnly: 'Тестовые',
        fulfillment: 'Выдача',
        product: 'Товар',
        query: 'Поиск',
        queryPlaceholder: 'Email, UID или номер заказа',
        from: 'С даты',
        to: 'По дату',
        apply: 'Применить',
        reset: 'Сбросить'
      },
      table: {
        created: 'Создан',
        order: 'Заказ',
        customer: 'Покупатель',
        product: 'Товар',
        amount: 'Сумма',
        status: 'Статус',
        fulfillment: 'Выдача',
        email: 'Письмо',
        actions: 'Действия'
      },
      uid: (uid: string): string => `UID ${uid}`,
      account: 'Аккаунт',
      attempts: (count: number): string => `Попыток выдачи: ${count}`,
      paidBy: (name: string, provider: string): string => `Оплату отметил: ${name} (${provider})`,
      provider: (provider: string): string => `Способ оплаты: ${provider}`,
      paymentCode: (code: string): string => `Код оплаты: ${code}`,
      funpayOrder: (id: string): string => `FunPay #${id}`,
      funpayOrderAria: (id: string): string => `Открыть заказ FunPay ${id} на FunPay`,
      disputeBadge: { dispute: 'Спор на FunPay', refund: 'Возврат на FunPay' },
      disputeAt: (date: string): string => `С ${date}`,
      paidComment: (comment: string): string => `Комментарий: ${comment}`,
      empty: 'Заказов по выбранным условиям нет',
      loadFailed: 'Не удалось загрузить заказы',
      actionFailed: 'Не удалось выполнить действие',
      markPaid: 'Отметить оплаченным',
      markPaidAria: (id: string): string => `Отметить заказ ${id} оплаченным`,
      retry: 'Повторить выдачу',
      retryAria: (id: string): string => `Повторить выдачу заказа ${id}`,
      cancel: 'Отменить заказ',
      cancelAria: (id: string): string => `Отменить заказ ${id}`,
      markPaidDialog: {
        title: 'Отметить заказ оплаченным',
        description: 'Заказ перейдёт в статус «Оплачен» и будет выдан покупателю. Действие записывается в аудит.',
        commentLabel: 'Комментарий (обязательно)',
        commentPlaceholder: 'Например: перевод на карту, чек №123',
        funpayHint: 'Для оплаты через FunPay укажите «FunPay #<номер заказа>»: номер привяжется к заказу и не даст выдать товар повторно.',
        commentRequired: 'Укажите комментарий',
        commentTooLong: 'Не более 500 символов',
        confirm: 'Отметить оплаченным',
        saving: 'Сохраняем…'
      },
      cancelDialog: {
        title: 'Отменить заказ',
        description: 'Заказ будет отменён. Это нельзя отменить.',
        confirm: 'Отменить заказ',
        back: 'Не отменять'
      },
      toasts: {
        markedPaid: 'Заказ отмечен оплаченным',
        retried: 'Выдача поставлена в очередь',
        canceled: 'Заказ отменён'
      }
    },
    analytics: {
      includeTest: 'Учитывать тестовые заказы',
      from: 'С даты',
      to: 'По дату',
      apply: 'Показать',
      paidCount: 'Оплаченных заказов',
      revenue: 'Выручка',
      noRevenue: 'Нет оплат за период',
      byProduct: 'По товарам',
      byDay: 'По дням',
      colProduct: 'Товар',
      colDate: 'Дата',
      colCount: 'Заказов',
      colAmount: 'Сумма',
      empty: 'Нет оплаченных заказов за период',
      loadFailed: 'Не удалось загрузить аналитику',
      barAria: (date: string, count: number, amount: string): string => `${date}: ${count} заказов, ${amount}`
    },
    payments: {
      loadFailed: 'Не удалось загрузить способы оплаты',
      empty: 'Способов оплаты пока нет',
      table: {
        method: 'Способ',
        id: 'ID',
        configured: 'Секреты',
        status: 'Статус',
        enabled: 'Включён'
      },
      configuredYes: 'Настроены',
      configuredNo: 'Не настроены',
      statusOn: 'Принимает оплату',
      statusOff: 'Выключен',
      adminOnly: 'Только админам',
      notConfiguredHint: 'Не настроены секреты: способ нельзя включить, пока их нет в окружении BE.',
      toggleAria: (name: string): string => `Включить способ оплаты ${name}`,
      updated: (name: string, enabled: boolean): string => `${name}: ${enabled ? 'включён' : 'выключен'}`
    },
    products: {
      create: 'Новый товар',
      loadFailed: 'Не удалось загрузить товары',
      empty: 'Товаров пока нет',
      table: {
        sort: 'Порядок',
        id: 'ID',
        name: 'Название',
        category: 'Категория',
        image: 'Фото',
        price: 'Цена',
        value: 'Выдача',
        status: 'Статус',
        actions: 'Действия'
      },
      edit: 'Изменить',
      editAria: (id: string): string => `Изменить товар ${id}`,
      active: 'Активен',
      inactive: 'Скрыт',
      categories: {
        host: 'Хост',
        supporter: 'Подписка',
        currency: 'Валюта',
        tag: 'Тег'
      },
      valueDays: (days: number): string => `${days} дн.`,
      valueCustom: 'Своё количество',
      valueCoins: (coins: string): string => `${coins} монет`,
      dialog: {
        createTitle: 'Новый товар',
        editTitle: 'Изменить товар',
        editHint: 'Изменение не влияет на уже созданные заказы.',
        id: 'ID (slug)',
        idHint: 'Строчные латинские буквы, цифры и дефис, 3–64 символа',
        lockedHint: 'Категорию и ID у существующего товара менять нельзя: от них зависит способ выдачи. Создайте новый товар и скройте старый.',
        category: 'Категория',
        name: 'Название',
        description: 'Описание',
        nameEn: 'Название (EN)',
        descriptionEn: 'Описание (EN)',
        featuresEn: 'Особенности (EN)',
        features: 'Особенности',
        featuresHint: 'По одной в строке',
        enHint: 'Пустое поле — на английском показывается русский текст',
        price: 'Цена, ₽',
        usdPrice: 'Цена, USD (необязательно)',
        valueDays: 'Срок, дней',
        valueCoins: 'Монет',
        badge: 'Метка',
        badgeNone: 'Без метки',
        badgePopular: 'Популярное',
        badgeBestValue: 'Выгодно',
        sortOrder: 'Порядок сортировки',
        featured: 'Выделить и выбрать по умолчанию',
        active: 'Показывать в магазине',
        saving: 'Сохраняем…',
        image: 'Картинка',
        imageHint: 'PNG, JPG или WebP, до 5 МБ',
        funpayLot: 'Лот FunPay',
        funpayLotHint: 'ID лота из ссылки FunPay (только цифры). Пусто — оплата через FunPay для товара недоступна.',
        funpayLotTitle: 'Название лота на FunPay',
        funpayLotTitleHint: 'Как в заголовке лота — по нему бот сопоставляет заказы.',
        imagePreviewAlt: 'Превью картинки товара',
        imageUpload: 'Загрузить',
        imageReplace: 'Заменить',
        imageRemove: 'Удалить',
        imageUploading: 'Загружаем…',
        customHint: 'Товар со свободным вводом монет: цену за количество считает сервер, срок и количество выдачи не задаются.',
        terms: {
          title: 'Сроки подписки',
          hint: 'Базовый срок — 1 месяц: его цена и длительность заданы выше. Здесь — дополнительные сроки; один месяц = 30 дней.',
          maxDiscount: 'Макс. скидка, %',
          maxDiscountHint: 'От 0 до 50. Потолок скидки и для автоматического расчёта, и для ручной скидки.',
          empty: 'Дополнительных сроков нет — у товара один срок.',
          months: 'Месяцев',
          discount: 'Скидка, %',
          discountPlaceholder: 'авто',
          discountHint: 'Пусто — скидка считается автоматически.',
          funpayLot: 'Лот FunPay (ID)',
          funpayLotTitle: 'Название лота FunPay',
          funpayHint: 'Лот FunPay срока: ID из ссылки (только цифры) и название, как в заголовке лота. Пусто — оплата через FunPay для этого срока недоступна.',
          active: 'Показывать',
          add: 'Добавить срок',
          remove: 'Удалить',
          removeAria: (months: string): string => `Удалить срок ${months} мес.`,
          rowAria: (months: string): string => `Срок ${months} мес.`,
          previewLabel: 'Расчёт',
          preview: (price: string, discount: string, monthly: string): string => `${price} · скидка ${discount}% · ≈ ${monthly} / мес.`,
          previewEmpty: 'Укажите корректный срок'
        }
      },
      errors: {
        imageTooLarge: 'Файл больше 5 МБ',
        imageUploadFailed: 'Не удалось загрузить картинку',
        id: 'ID: 3–64 символа, a-z, 0-9 и дефис',
        name: 'Укажите название',
        price: 'Цена должна быть больше нуля',
        usdPrice: 'Цена в USD должна быть больше нуля',
        value: 'Значение выдачи должно быть целым числом больше нуля',
        sortOrder: 'Порядок должен быть целым числом',
        description: 'Укажите описание',
        priceScale: 'Цена: больше нуля, не более двух знаков после запятой',
        usdScale: 'Цена в USD: больше нуля, не более двух знаков после запятой',
        nameLong: 'Название не длиннее 255 символов',
        nameEnLong: 'Название (EN) не длиннее 255 символов',
        descriptionEnLong: 'Описание (EN) не длиннее 5000 символов',
        featuresCount: 'Не более 20 особенностей',
        featureLong: 'Каждая особенность не длиннее 255 символов',
        funpayLot: 'Лот FunPay: только цифры, от 1 до 20',
        funpayLotTitleLong: 'Название лота не длиннее 255 символов',
        termMax: 'Максимальная скидка: целое число от 0 до 50',
        termMonths: 'Срок подписки: целое число месяцев от 2 до 24',
        termDuplicate: 'Сроки подписки не должны повторяться',
        termDiscount: 'Скидка срока: число от 0 до максимальной скидки, не более двух знаков после запятой',
        duplicate: 'Товар с таким ID уже существует',
        save: 'Не удалось сохранить товар'
      },
      toasts: {
        created: 'Товар создан',
        updated: 'Товар обновлён'
      }
    },
    categories: {
      loadFailed: 'Не удалось загрузить категории',
      empty: 'Категорий пока нет',
      hint: 'Названия и описания категорий показываются на витрине. Набор категорий фиксирован.',
      table: {
        sort: 'Порядок',
        id: 'ID',
        title: 'Название',
        description: 'Описание',
        actions: 'Действия'
      },
      edit: 'Изменить',
      editAria: (id: string): string => `Изменить категорию ${id}`,
      dialog: {
        title: 'Изменить категорию',
        titleRu: 'Название (RU)',
        titleEn: 'Название (EN)',
        descriptionRu: 'Описание (RU)',
        descriptionEn: 'Описание (EN)',
        sortOrder: 'Порядок (0–1000)',
        saving: 'Сохраняем…'
      },
      errors: {
        title: 'Укажите названия на обоих языках (не длиннее 64 символов)',
        description: 'Описание не длиннее 500 символов',
        sortOrder: 'Порядок должен быть целым числом от 0 до 1000'
      },
      toasts: {
        updated: 'Категория обновлена'
      }
    }
  }
};
